import { z } from 'zod';

/**
 * Tolerant reader for error bodies that are not (yet) RFC 9457 conformant: proxy and gateway
 * errors (502/503/504 from nginx/Traefik), legacy controllers that render a bare `{ code }`.
 *
 * Use it ONLY where the backend is not yet conformant, and only as a fallback; prefer
 * ProblemJsonSchema, which every `render_problem_json` answer satisfies.
 *
 * Every member is optional in practice: a missing or malformed member reads as null instead of
 * failing the parse. Extension members pass through. A hardened ProblemJsonSchema body always
 * parses here unchanged (the spec guards that this reader is never stricter than the default).
 */
export const LegacyProblemJsonSchema = z
  .object({
    type: z.string().nullable().catch(null),
    title: z.string().nullable().catch(null),
    status: z.number().int().nullable().catch(null),
    detail: z.string().nullable().catch(null),
    instance: z.string().nullable().catch(null),
    request_id: z.string().nullable().catch(null),
    code: z.string().nullable().catch(null),
  })
  .passthrough();

export type TLegacyProblemJson = z.infer<typeof LegacyProblemJsonSchema>;
